import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { RecallProductsListItem } from 'src/app/models';
import { DynamicComponent } from 'src/app/components/base/dynamic.component';
import { PluginService } from 'src/app/services';

@Component({
    selector: 'recallproductslist-item-component',
    templateUrl: 'recallproductslist.item.component.html'
})
export class RecallProductsListComponent extends DynamicComponent implements OnInit {

    constructor(public pluginService: PluginService) {
        super(pluginService);
    }

    @Input() item: RecallProductsListItem;

    @Output() delete = new EventEmitter();

    ngOnInit() {
    }

    setValue(i , e){
      if(e.checked){
        this.item.field_6 = 1;
      }else{
        this.item.field_6 = 0;
      }
    }

    getValue(){
      return this.item.field_6 == 1 ? true : false;
    }
}
